import React from 'react'
import { Router, Route, Redirect, Switch } from 'react-router-dom'
import qhistory from 'qhistory'
import { createBrowserHistory } from 'history'
import qs from 'qs'

import { LibraryPricing } from './components/library/LibraryPricing'
import LibraryWrap from './components/library/LibraryWrap'
import { NevadaCaseStudy } from './components/library/NevadaCaseStudy'
import { LibraryQuoteForm } from './components/library/LibraryQuoteForm'
import { LibraryQuoteFormConfirmation } from './components/library/LibraryQuoteFormConfirmation'
import { LibraryRequestDemoForm } from './components/library/LibraryRequestDemoForm'
import { LibraryRequestDemoFormConfirmation } from './components/library/LibraryRequestDemoFormConfirmation'

export const browserHistory = qhistory(createBrowserHistory(), qs.stringify, qs.parse)

export default class LibraryRoutes extends React.Component {
  /*
   *            webinar registration route
   *            <Route
   *                path=":state/webinar(/:response)"
   *                component={ WebinarResponseForm }
   *            />
   */
  constructor() {
    super()
    browserHistory.listen(location => {
      window.ga?.('set', 'page', location.pathname + location.search)
      window.ga?.('send', 'pageview')
    })
  }

  render() {
    return (
      <Router history={browserHistory}>
        <LibraryWrap>
          <Switch>
            <Route path="/pricing" component={LibraryPricing} />

            <Route path="/quote" component={LibraryQuoteForm} />
            <Route path="/quote/confirm" component={LibraryQuoteFormConfirmation} />
            <Route path="/requestdemo" component={LibraryRequestDemoForm} />
            <Route
              path="/requestdemo/confirm"
              component={LibraryRequestDemoFormConfirmation}
            />

            <Route path="/casestudy/nevada" component={NevadaCaseStudy} />

            <Redirect from="*" to="/" />
          </Switch>
        </LibraryWrap>
      </Router>
    )
  }
}
